module.exports = __webpack_public_path__ + "static/media/creative.e6d89935.jpeg";